var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"crisp-image",attrs:{"src":require("@/assets/images/ico061.svg"),"alt":"Choose Lab Request"}}),_c('text-string',{attrs:{"label-id":"txt371"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }